( function( global, $ ) {

    $(document).on('click' , '[gr-tooltip-trigger]', function(event) {
        event.preventDefault();

        var tooltip = $(this).closest('[gr-tooltip]');

        $('[gr-tooltip]').not(tooltip).removeClass('is-open');

        $('.card-horizontal').removeClass('tooltip-open');

        if (tooltip.hasClass('is-open')) {
            tooltip.removeClass('is-open');
            $(this).closest('.card-horizontal').removeClass('tooltip-open');
        } else {
            tooltip.addClass('is-open');
            $(this).closest('.card-horizontal').addClass('tooltip-open');
        }
    });

}( window.groots, jQuery ));
